<template>
    <div style="width: 100%;">
        <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack"></van-nav-bar>
        <div style="width: 100%;height:50px;"></div>
        <div
            style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
            <!-- <div class="text"></div> -->
            <my-text-one :title="teamName + '团队视频墙'" :textContent="teamName + '团队视频墙'"></my-text-one>
            <div class="list-view" :style="{ height: screenHeight }">
                <el-row :gutter="20">
                    <el-col :span="24" v-for="i in playerNum" :key="i" @click="currentIndex = i">

                        <el-card :body-style="{ padding: '0px' }">
                            <live-player ref="player" :video-title="videoList[i - 1] ? videoList[i - 1].title : ''"
                                :video-url="videoList[i - 1] ? videoList[i - 1].video : ''" style="height: 100%"
                                :autoplay="autoplay" :muted="muted" @error="restartPlayer" @ended="restartPlayer"
                                :live="false" :controls="true" :poster="videoList[i - 1].coverUrl">
                            </live-player>
                            <div style="padding: 14px;padding-bottom: 5px; margin-top: 0px;margin-bottom: 0px;"
                                @click="goVideoContent(i - 1)">

                                <div class="nav">
                                    <span style="--i:1">{{ videoList[i - 1].title }}</span>

                                </div>

                            </div>
                            <div style="color: skyblue;padding-left: 14px">
                                <div class="ql-editor" v-html="videoList[i - 1].absContent"></div>
                            </div>
                            <div style="height: 10px;"></div>
                        </el-card>
                    </el-col>

                </el-row>

            </div>
            <div class="kuang">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
    </div>

</template>

<script>
import LivePlayer from '@liveqing/liveplayer'
import MyTextOne from "@/components/MyTextOneMobile.vue";
export default {
    name: 'ShowVideo',
    components: {
        LivePlayer,
        MyTextOne,
    },
    data() {
        return {
            // 屏幕宽度
            screenWidth: window.screen.width,
            // 屏幕高度
            screenHeight: (window.screen.height - 190) + "px",
            // 分屏布局
            playerNum: 0,
            colSpan: 24,
            currentIndex: 0,
            // 视频播放器
            muted: false,
            autoplay: false,
            videoList: [

            ],

            dataForm: {
                key: ''
            },
            pageIndex: 1,
            pageSize: 10,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        };
    },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('/app/video/list'),
                method: 'get',
                params: this.$http.adornParams({
                    'page': this.pageIndex,
                    'limit': this.pageSize,
                    'key': this.dataForm.key
                })
            }).then(({ data }) => {
                console.log(data);
                if (data && data.code === 0) {
                    this.videoList = data.page.list
                    this.playerNum = data.page.totalCount
                } else {
                    this.videoList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        goVideoContent(index) {
            console.log(index);
            let data = this.videoList[index]
            console.log(data);
            this.$router.push({
                name: "VideoContentMobile",
                params: {
                    data: data
                }
            })

        },
        splitScreen(span, num) {
            this.colSpan = span
            this.playerNum = num
            if (this.currentIndex > num) {
                this.currentIndex = 1
            }
        },
        restartPlayer() {
            let [player] = this.$refs.player
            player = player.getVueInstance()
            player.initPlayer()  // 重新初始化播放器
        },
        onClickLeftBack() {
            this.$router.back()
        },
    },
    mounted() {
        this.getDataList()
        console.log(this.screenHeight);
    },
    created() {
    }
}
</script>
<style lang="less" scoped>
.van-nav-bar {
    background-color: #00000000;
}

/* 需要滚动条隐藏的列表 */
.list-view {
    width: 95%;
    // height: 700px;
    margin-top: 30px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

.el-card {
    background-color: rgba(255, 255, 255, 0.4) !important;

    box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

    backdrop-filter: blur(50px) !important;
    border: none !important;
    border-radius: 10px !important;
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
    margin-bottom: 30px
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

/**背景 **/

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}

/** 发光字体 */
.nav {
    position: relative;
    font: 10 12pt '';
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
}

.nav:hover span {
    color: #FFFFFF;
    text-shadow: 0 0 10px #FFFFFF,
        0 0 20px #FFFFFF,
        0 0 30px #FFFFFF,
        0 0 50px #FFFFFF,
        0 0 70px #FFFFFF,
        0 0 90px #FFFFFF;

}
</style>
